'use client'

import { TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { cn } from '@/lib/css-utils'
import { JSX } from 'react'

export function SalaryTableHeader({
  className,
  isShowingSalaryDetails,
  isHourlyPayPeriod,
  isLocumsOrPrn,
}: {
  className?: string
  isShowingSalaryDetails?: boolean
  isHourlyPayPeriod?: boolean
  isLocumsOrPrn?: boolean
}): JSX.Element {
  const columns = [
    { key: 'posted', label: 'Posted', className: 'max-w-16 pl-3 pr-0' },
    { key: 'clinical_details', label: 'Clinician Details', className: '' },
    {
      key: 'location_employer',
      label: isLocumsOrPrn ? 'Location & Setting' : 'Location & Employer',
      className: '',
      hidden: isShowingSalaryDetails,
    },
    {
      key: 'pto_benefits',
      label: isLocumsOrPrn ? 'Contract' : 'PTO & Benefits',
      className: 'min-w-32',
      hidden: isShowingSalaryDetails || isLocumsOrPrn,
    },
    { key: 'schedule', label: 'Schedule', className: 'min-w-36' },
    {
      key: 'total_comp',
      label: isHourlyPayPeriod ? 'Hourly Comp' : 'Total Comp',
      className: 'min-w-36 text-right',
    },
  ]

  return (
    <TableHeader className={className}>
      <TableRow className="hover:bg-background-primary">
        {columns
          .filter((column) => !column.hidden)
          .map((column) => {
            return (
              <TableHead key={column.key} className={cn(column.className)}>
                {column.label}
              </TableHead>
            )
          })}
      </TableRow>
    </TableHeader>
  )
}
